export default function textField({ variables, }) {
    return {
        MuiTextField: {
            defaultProps: {
                variant: "outlined",
            },
            styleOverrides: {
                root: {
                    "& .MuiFormHelperText-root": {
                        fontSize: variables.type_caption_font_size,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=textField.js.map